import { Button, Typography } from "@/components/atoms";
import { BankAccount } from "@/redux/apis/bankAccount/types";
import { BankDetailsStep } from "../types";

interface BankDetailsViewProps extends React.HTMLAttributes<HTMLDivElement> {
  setStep: (step: BankDetailsStep) => void;
  bankAccount?: BankAccount;
}

export const BankDetailsView = ({ setStep, bankAccount, className, ...props }: BankDetailsViewProps) => {
  const bankAccountDetails = bankAccount?.auBankAccount;

  return (
    <div className={className} {...props}>
      <div className="mt-3 grid grid-cols-2 gap-4 rounded-lg border border-neutral-mid-gray bg-neutral-surface-gray p-5">
        <div className="col-span-2 flex flex-col sm:col-span-1">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Full Name
          </Typography>
          <Typography variant="paragraph">{bankAccountDetails?.accountHolder ? bankAccountDetails.accountHolder : "-"}</Typography>
        </div>
        <div className="col-span-2 flex flex-col sm:col-span-1">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Account number
          </Typography>
          <Typography variant="paragraph">{bankAccountDetails?.accountNumber ? bankAccountDetails.accountNumber : "-"}</Typography>
        </div>
        <div className="col-span-2 flex flex-col sm:col-span-1">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Bank State Branch
          </Typography>
          <Typography variant="paragraph">{bankAccountDetails?.bsb ? bankAccountDetails.bsb : "-"}</Typography>
        </div>
      </div>
      <div className="mt-4 flex flex-row justify-end">
        <Button variant="secondary" size="sm" startIcon="Edit2" className="w-full sm:w-fit" onClick={() => setStep("edit")}>
          Update Bank Details
        </Button>
      </div>
    </div>
  );
};
